import { isAuthError, isForbiddenError } from '@/context/services/type';
import { useCallback } from 'react';
import type { CheckPermissionFn } from '../type';

export type { CheckPermissionFn };

/**
 * We are using the api list reports to check if the user has permission to access the protected resources
 * if status return 403 or 401, we will reload the page
 * Check if the user has permission to access the protected resources
 */

export const useCheckProtectedResources = () => {
  const handleCheckPermission = useCallback(
    async ({
      fnCheckPermission,
      onCheckSuccess,
      onCheckFailure,
    }: {
      fnCheckPermission?: CheckPermissionFn;
      onCheckSuccess: () => void;
      onCheckFailure: () => void;
    }) => {
      try {
        if (!fnCheckPermission) return;
        const result = await fnCheckPermission();
        const status = result?.data?.status;
        if (result?.data && (isAuthError(status) || isForbiddenError(status))) {
          onCheckFailure();
        } else {
          onCheckSuccess();
        }
      } catch {
        onCheckFailure();
      }
    },
    []
  );

  return {
    handleCheckPermission,
  };
};
